export const phoneNumberRegex = "^\\+?([ -]*\\d){11,13}$";
export const normalizePhoneNumber = (phoneNumber: string): string => {
  if (phoneNumber.length === 0) {
    return phoneNumber;
  }
  const withoutWhitespace = phoneNumber.replace(/\s+/g, '');
  const withoutDashes = withoutWhitespace.replace(/-/g, '');
  const withPlusInFront = phoneNumber.charAt(0) === '+' ? withoutDashes : '+' + withoutDashes;
  return withPlusInFront;
}
